<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "PaymentBatchTemplatesView",
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>

</style>